import { gql, useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';

const GENERATE_LANDING_PAGE_LINK_MUTATION = gql`
  mutation GenerateLandingPageLink($params: GenerateLandingPageLinkInput!) {
    generateLandingPageLink(params: $params) {
      url
    }
  }
`;

interface GenerateLandingPageLinkMutation {
  generateLandingPageLink: {
    url: string;
  };
}

export const useLandingPageLink = () => {
  const [generateLandingPageLinkMutation] = useMutation<GenerateLandingPageLinkMutation>(
    GENERATE_LANDING_PAGE_LINK_MUTATION,
  );

  const generateLandingPageLink = useCallback(
    async (params: { partnerId: number; addressId: string }) => {
      const { data } = await generateLandingPageLinkMutation({ variables: { params } });

      return data?.generateLandingPageLink.url ?? '';
    },
    [generateLandingPageLinkMutation],
  );

  return { generateLandingPageLink };
};
